import React, {Component, Fragment} from 'react';
import {jsonResponseHandler} from "../../utils/FetchHelper";
import * as InitStatus from "../../constants/common/InitializationStatus";
import fetch from "fetch-retry";
import If from "../common/control/If";
import Loading from "../common/Loading";
import RetryView from "../statistics/common/RetryView";
import {addPrefix} from "../../utils/UriUtil";

class DashboardKeyword extends Component {

  constructor(props) {
    super(props);
    this.state = {
      initialized: InitStatus.INIT_READY,
      list: []
    };
  }

  // Mount후 API 호출
  componentDidMount() {
    this.getKeyword();
  }


  // 키워드 정보 호출
  getKeyword = () => {
    const {dispatch} = this.props;
    this.setState({initialized: InitStatus.INIT_DOING}, () => {
      fetch(addPrefix("/manage/statistics/dashboard/keyword.json"), {
        credentials: 'include',
        headers: {'Content-Type': 'application/json'},
        retries: 2,
        retryDelay: 300,
        retryOn: [500]
      })
        .then(jsonResponseHandler(dispatch))
        .then(res => res.json())
        .then(res => {
          const data = res.data;
          const result = data && data.hasOwnProperty('result') ? data.result : [];
          this.setState({
            initialized: InitStatus.INIT_SUCCESS,
            list: result ? result : []
          });

        })
        .catch(e => {
          console.error(e);
          this.setState({initialized: InitStatus.INIT_FAIL});
        })
    });
  };

  // 로딩 렌더링
  renderLoading() {
    return <div className="box_loading">
      <span className="ico_blog ico_loading">로딩중입니다.</span>
    </div>;
  }

  // 리스트 렌더링
  renderItems(list) {
    if (list) {
      return list.map((item, index) => {
        const count = item.count > 9999 ? "9999+" : item.count;
        return <li key={index}>
          <span className="btn_keyword "><span className="txt_keyword">{item.keyword}</span><span className="num_keyword">{count}</span></span>
        </li>
      });
    }
  }

  // Root 렌더링
  render() {
    const {initialized, list} = this.state;
    const {isDoing, isEmpty, isFail, isSuccess} = InitStatus.init(initialized, list);
    return (
      <div className="box_blog_type1 box_keyword">
        <strong className="tit_box">유입 키워드</strong>
        <If condition={isFail}> <RetryView retryCallback={this.getKeyword}/> </If>
        <If condition={isSuccess}>
          <Fragment>
            <If condition={isEmpty}><p className="txt_none">유입된 키워드가 없습니다.</p></If>
            <If condition={!isEmpty}>
              <ul className="list_keyword">
                {this.renderItems(list)}
              </ul>
            </If>
          </Fragment>
        </If>
        <If condition={isDoing}><Loading/></If>
      </div>
    );
  }
}

DashboardKeyword.propTypes = {};
export default DashboardKeyword;
